import { Component, Input, OnInit } from "@angular/core";
import { EdpModalService } from "@edp-components/edp-modal";
import { IModalData } from "@edp-components/edp-modal/edp-modal.models";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "modal-contract-confirm-changes",
    templateUrl: "./modal-contract-confirm-changes.component.html",
    styleUrls: ["./modal-contract-confirm-changes.component.scss"],
})
export class ModalConfirmChangesComponent implements OnInit {
    @Input() public data: IModalData;
    @Input() public title: string;
    @Input() public message: string;

    customTitle: string;
    text: string;
    customDescription: string;

    constructor(private readonly edpModalService: EdpModalService, private translate: TranslateService) {}

    ngOnInit(): void {
        const typeTitle = this.translate.instant(`pt.edp.edponline.modal.contract.confirm.changes.title.${this.data.collection.type}`);
        this.customTitle = this.translate.instant("pt.edp.edponline.modal.contract.confirm.changes.title", {
            TYPE: typeTitle,
        });
        if (!!this.data.collection.change) {
            this.customDescription = this.translate.instant("pt.edp.edponline.modal.contract.confirm.changes.description", {
                CHANGE: this.data.collection.change,
            });
        }
    }

    public closeModal(action: boolean): void {
        this.edpModalService.close(action);
    }

    public dismissModal(action: boolean): void {
        this.edpModalService.dismiss(action);
    }

    public advance() {
        if (!!this.data.collection.fn) {
            this.data.collection.fn();
        } else {
            this.closeModal(true);
        }
    }
}
